// ----------------------------------------------------------------------
//
// NAT-2481 — one strict parser for "is this wire value actually a usable number", shared by
// every place in this PR that turns a JSON field into a number. `Number(v)` alone is not safe
// for this: `Number(null)` is `0`, `Number('')` is also `0`, and both are finite — so a missing
// figure silently becomes a real, reportable zero. Booleans and other non-numeric shapes are
// rejected by type rather than left to `Number()`'s own coercion (`Number([5])` is `5`).

/**
 * Parses a wire value as a finite number, or null if it is not one. Rejects a blank or
 * whitespace-only string, and anything that is not a `number` or a `string` in the first place —
 * which already covers `null` and `undefined` (`typeof` is `'object'` and `'undefined'`, neither
 * is `'number'` or `'string'`), so there is no separate null check to drift out of sync with it.
 * Also rejects anything that does not convert to a finite number (`NaN`, `Infinity`, non-numeric
 * text).
 */
export function toFiniteNumber(value: unknown): number | null {
  if (typeof value === 'string' && value.trim() === '') return null;
  if (typeof value !== 'number' && typeof value !== 'string') return null;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
